export const GET_NOTIFICATION :string = "/Notification";
export const UPDATE_NOTIFICATION_STATUS :string = "/updateNotificationStatus";


